// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from show-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function ShowFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 2c4.36 0 8 2.6 8 6s-3.64 6-8 6c-4.36 0-8-2.6-8-6s3.64-6 8-6Zm0 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
      />
    </svg>
  );
}
